module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--title"
  }, [_vm._v("\n        " + _vm._s(_vm.staticTitle) + "\n      ")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.staticImage) ? [_c('div', {
    staticClass: "static-info--image"
  })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.staticSubTitle) ? _c('h3', {
    staticClass: "static-info--sub-title"
  }, [_vm._v("\n        " + _vm._s(_vm.staticSubTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show"
    }],
    staticClass: "static-info--teaser",
    attrs: {
      "staticCopy": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.staticCopy) + "\n\n      ")]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.buttonsGroup) ? [_c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Dowload Nda Document")])] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e14a0f4a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/static-page/static-info-left-image/static-info-left-image.vue
// module id = 947
// module chunks = 0